import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";

const HIGHLIGHT_COLOR = "rgba(100, 100, 255, 1.0)";
export const StaggeredParticle = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: HIGHLIGHT_COLOR,
  bg: null,
  animate: async (particle: Particle<string | null>) => {
    const baseColor = particle.options || "rgba(100, 100, 100, 1.0)";
    // eslint-disable-next-line no-constant-condition
    while (true) {
      await awaitAnimate({
        driver: particle.driver,
        from: baseColor,
        to: HIGHLIGHT_COLOR,
        duration: 1000,
        onUpdate: (latest) => {
          particle.fg = latest;
        },
      });

      await awaitAnimate({
        driver: particle.driver,
        from: HIGHLIGHT_COLOR,
        to: baseColor,
        duration: 1000,
        onUpdate: (latest) => {
          particle.fg = latest;
        },
      });
    }
  },
};
